module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes--1-fc946581.png";